import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import media from './media'
import auth from './auth'
import user from './user'
import joyride from './joyride'
import structures from './structures'
import projects from './projects'
import { reducer as notifReducer } from 'redux-notifications';

export default combineReducers({
  routing: routerReducer,
  notifs: notifReducer,
  auth,
  user,
  media,
  structures,
  projects,
  joyride
})



// WEBPACK FOOTER //
// ./src/modules/index.js